import Claims from './claims'
import { currentPortalAudience, isAdminDomain, isPartnerDomain, isSupportDomain } from './currentDomain'
import { SiteDomain } from './portalDomain'
import { CurrentUser } from './currentUser'

type PortalAccessUser = {
    id?: string
    isSuperAdmin?: boolean
    isPartner?: boolean
    partnerId?: number | null
    roles?: Array<{ claim?: string | null }>
}

// Apply a specific portal's access rule to a hydrated user object.
export const hasPortalAccessForDomain = (
    user: Partial<CurrentUser> | PortalAccessUser | null | undefined,
    currentDomain: SiteDomain | null
): boolean => {
    if (!user?.id) return false

    if (currentDomain === SiteDomain.SUPPORT) {
        return Boolean(user.isSuperAdmin)
    }

    if (currentDomain === SiteDomain.PARTNER) {
        return Boolean(user.isPartner && user.partnerId)
    }

    if (currentDomain === SiteDomain.ADMIN) {
        return Boolean(
            user.isSuperAdmin ||
                user.roles?.some((role) => role?.claim === Claims.Admin || role?.claim === Claims.AdminViewOnly)
        )
    }

    return true
}

// Apply the current portal's access rule to a hydrated user object.
export const hasPortalAccess = (user?: Partial<CurrentUser> | PortalAccessUser | null): boolean =>
    hasPortalAccessForDomain(
        user,
        isSupportDomain
            ? SiteDomain.SUPPORT
            : isPartnerDomain
              ? SiteDomain.PARTNER
              : isAdminDomain
                ? SiteDomain.ADMIN
                : null
    )

// Compare a backend audience to an explicit current portal audience.
export const hasMatchingPortalAudienceForAudience = (
    portalAudience: string | null | undefined,
    currentAudience: string | null
): boolean => Boolean(currentAudience && portalAudience && portalAudience === currentAudience)

// Verify that backend session audience matches the portal currently mounted in the browser.
export const hasMatchingPortalAudience = (portalAudience?: string | null): boolean =>
    hasMatchingPortalAudienceForAudience(portalAudience, currentPortalAudience)
